import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { Button } from '@material-ui/core'
import { useAuthDataContext } from '../../../../__providers/AuthProvider'
import Api from '../../../../__helpers/api'
import { useHistory } from 'react-router-dom'

//images
import mainImage from '../../../../assets/images/modals/messages/just-activated/icons/main.png'
import closeIcon from '../../../../assets/images/modals/messages/feedback/icons/close.png'
import stepsIcon from '../../../../assets/images/modals/messages/just-activated/icons/steps.png'
import bookIcon from '../../../../assets/images/modals/messages/just-activated/icons/book.png'
import testIcon from '../../../../assets/images/modals/messages/just-activated/icons/test.png'

//actions
import { refreshNotification } from '../../../../__actions/notifications'
import { handleModal } from '../../../../__actions/globalModals'

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

function JustActivated(props, ref) {
    const history = useHistory()
    const auth = useAuthDataContext()
    const dispatch = useDispatch()

    //
    const __data = useSelector(state => state)
    //
    const data = __data?.globalModalsReducer?.JUST_ACTIVATED?.data || {}

    const [state, setState] = useState({
        blur: false,
        popup: false,
    })

    useImperativeHandle(ref, () => ({
        open: () => handleOpen(),
        close: () => handleClose()
    }))

    const handleOpen = () => {
        setState(state => ({
            ...state,
            blur: true,
        }))

        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        dispatch(handleModal('JUST_ACTIVATED', false, {}))

        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'

        history.push('/')

        Api.post('notifications/mark-as-read', {
            id: data?.id
        })
            .then(() => {
                dispatch(refreshNotification())
            })

        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
            }))
        }, 100)
    }


    return (
        <div id="overlay" className={`scrollable-mobile ${state.blur ? 'visible' : ''}`}>

            <div className={`box just-activated-modal ${state.popup ? 'show' : ''}`}>
                <img src={closeIcon} className="close" onClick={handleClose} />
                <img src={mainImage} className="main" />
                <h2>
                    {data?.name}, ти успешно активира Авто Обучение!
                </h2>
                <p>
                    Авто Обучение те води последователно и ти гарантира, че ще преминеш през всички изпитни въпроси. Обучението е разделено по теми, защото усвояването на учебен материал на части ти осигурява трайни знания и сигурен успех на изпита.
                </p>
                <ul>
                    <li>
                        <img src={stepsIcon} />
                        Последователно
                        преминаваш през
                        всички 19 теми
                    </li>
                    <li>
                        <img src={bookIcon} />
                        Гарантирано
                        преминаваш през
                        целия учебен материал
                    </li>
                    <li>
                        <img src={testIcon} />
                        Гарантирано
                        преминаваш всички
                        изпитни въпроси
                    </li>
                </ul>
                <Button onClick={handleClose} className="primary">
                    Към темите
                </Button>
            </div>
        </div >
    )
}

export default forwardRef(JustActivated)